import * as React from 'react';
import Box from '@mui/material/Box';
import Top from "../Top";
import Bottom from "../Bottom";

const Ads = () => {

  
  return (
    <Box sx={{ minWidth: 320 }}>
      <Top title="제3자 개인정보 제공 동의(건강검진 및 심리상담)" />

      <Box className={'contentStart'}
        sx={{
          p: '0 15px 80px 15px',
          mt: 10,
          '& > p': {
            margin: '6px',
            fontSize: 12,
          },
          'ol': { paddingLeft: '20px' },
          'ol li': { mb: '10px', fontSize: 12 },
          'ul': { paddingLeft: '20px', mt: '5px' },
          'ul li': { fontSize: 12, mb: 0 },
          'h2': { textAlign: 'center', fontSize: 18 },
          'h3': { fontSize: 14 },
          'table': { mt: '10px', borderCollapse: 'collapse', overflow: 'scroll', minWidth: 270, whiteSpace: 'nowrap', display: 'block' },
          'th': { border: '1px solid #ccc', background: '#f1f1f1', textAlign: 'center', padding: '5px', fontSize: 12, },
          'td': { border: '1px solid #ccc', padding: '5px', fontSize: 12, whiteSpace: 'normal' },
          '.bold': { fontSize: 12, fontWeight: 700 }


        }}>

        <h2>듀얼헬스케어<br />제3자 개인정보 제공 동의(건강검진 및 심리상담)</h2>
        <p>&nbsp;</p>


        <p className='bold'>㈜듀얼헬스케어(이하 “회사” ) 사용자(또는 회원)의 개인정보 보호를 매우 중요시하며, 『개인정보 보호법』, 『정보통신망 이용촉진 및 정보 보호에 관한 법률』 등 개인정보 보호규정 및 정보통신부가 제정한 『개인정보 보호지침』을 준수합니다.
        </p>
        <p>&nbsp;</p>

        <p>회사는 아래의 내용과 같이 사용자의 개인 정보를 수집 및 이용 동의를 받고자 합니다.
        </p>
        <table>
          <colgroup>
            <col width='25%' />
            <col width='30%' />
            <col width='30%' />
            <col width='15%' />
          </colgroup>
          <tbody>
            <tr>
              <th>제공 받는 자</th>
              <th>제공 목적</th>
              <th>제공 항목</th>
              <th>보유 기간</th>
            </tr>
            <tr>
              <td>건강검진 사용자 신청 병∙의원과 심리상담 사용자 신청 심리상담소</td>
              <td>서비스 이용(건강검진, 심리상담 예약 서비스)과 고객 상담, 불만처리 및 요금 정산</td>
              <td>이름, 성별, 생년월일, 휴대전화번호, 주소, 예약정보(건강검진/심리상담 예약일, 검진패키지명, 금액 등), 소속회사</td>
              <td>회원 탈퇴 후 2년</td>
            </tr>
          </tbody>
        </table>

        <p>※ 동의를 거부하는 경우 해당 서비스 이용이 불가능하며 이외의 서비스 이용에 영향을 끼치지 않습니다. 또한 동의 철회 및 개인(민감)정보 파기를 원하는 경우 당사의 개인정보 처리방침을 참고 바랍니다. </p>




      </Box>



      <Bottom />

    </Box>

  );
}


export default Ads;